import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Paper from "@limitless/modern/surfaces/paper/Paper";
const VerticalTabWithPaperContainer = ({
  tabContent,
  paperContent,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    sx: {
      backgroundColor: theme => theme.palette.background.default,
      height: "100vh",
      overflowY: "auto"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: {
      width: "285px"
    },
    mb: 5
  }, tabContent), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: "40px 48px",
      marginRight: 4,
      marginTop: 5,
      marginBottom: 10,
      ...rest.sx
    }
  }, paperContent)));
};
export default VerticalTabWithPaperContainer;
VerticalTabWithPaperContainer.propTypes = {
  tabContent: PropTypes.node.isRequired,
  paperContent: PropTypes.node.isRequired
};